import { Upload as ANTUpload } from "antd";
import styled from "styled-components";

const Upload = styled(ANTUpload)``;

export default Upload;
